import React from "react";
import { motion } from "framer-motion";
import { Eye } from "lucide-react";
import Navbar from "../../components/Navbar";

const visionPoints = [
  "Become a globally trusted consulting and certification partner",
  "Set benchmarks for quality, compliance, and sustainability",
  "Enable organizations to compete confidently in global markets",
  "Drive innovation through internationally recognized standards",
];

const Vision = () => {
  return (
    <>
    <Navbar />
    <section className="bg-white py-16 sm:py-12 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* ===== Header ===== */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="max-w-3xl mx-auto text-center mb-14"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-[var(--bg-primary)] mb-4">
            Our Vision
          </h2>
          <div className="w-20 h-1 bg-[var(--bg-primary)] mx-auto rounded-full mb-4" />
          <p className="text-gray-600 text-base md:text-lg leading-relaxed">
            Our vision is to shape the future of organizations by promoting
            excellence, global compliance, and sustainable growth across
            industries worldwide.
          </p>
        </motion.div>

        {/* ===== Content Grid ===== */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

          {/* ===== Left Card ===== */}
          <motion.div
            initial={{ opacity: 0, scale: 0.92 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            whileHover={{
              y: -8,
              boxShadow: "0px 25px 50px rgba(59,130,246,0.25)",
            }}
            className="relative bg-gray-50 rounded-2xl border border-gray-100 p-8 shadow-lg overflow-hidden group"
          >
            {/* Glow */}
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 via-transparent to-purple-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

            <h4 className="relative z-10 text-xl font-bold text-gray-900 mb-4">
              Shaping the Future
            </h4>

            <p className="relative z-10 text-gray-600 leading-relaxed mb-4">
              At <span className="font-semibold text-gray-900">MBA Solutions</span>,
              we envision a world where organizations operate with confidence,
              transparency, and global credibility through recognized standards.
            </p>

            <p className="relative z-10 text-gray-600 leading-relaxed">
              Our vision is driven by continuous learning, innovation, and a
              commitment to helping businesses achieve long-term excellence.
            </p>
          </motion.div>

          {/* ===== Right Content ===== */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Our Long-Term Vision
            </h3>

            <div className="space-y-4">
              {visionPoints.map((point, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                  className="flex items-start gap-3"
                >
                  <Eye className="w-6 h-6 text-[var(--bg-primary)] mt-0.5 flex-shrink-0" />
                  <p className="text-gray-700 leading-relaxed">
                    {point}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>

        </div>
      </div>
    </section>

    </>
  );
};

export default Vision;
